import fuelCardActions from "actions/fuelCards";
import { connect } from "helpers/redux";
import { paramsObject } from "helpers/system";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/fuelCards";
import Form from "./form";
import List from "./list";
import Show from "./show";

class FuelCards extends Component {
    componentWillUnmount() {
        this.props.clearParams();
    }

    render() {
        const { match, location, history } = this.props;
        const rootUrl = `${match.path}/list`;
        const { tab = "all" } = paramsObject(location.search);
        const back = () => history.push(`${rootUrl}?tab=${tab}`);
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={`${rootUrl}?tab=all`} />} />
                    <Route
                        exact
                        path={rootUrl}
                        render={(props) => {
                            const { tab } = paramsObject(props.location.search);
                            return (
                                <List
                                    {...this.props}
                                    tab={tab}
                                    isTable
                                    transition="full"
                                    title="Топливные карты"
                                    nofilter
                                />
                            );
                        }}
                    />
                    <Route
                        path={`${match.path}/new`}
                        render={() => <Form {...this.props} title="Добавить карту" back={back} submit={source.apply} />}
                    />
                    <Route
                        path={`${rootUrl}/:id`}
                        render={(rest) => (
                            <Show {...rest} transition="full" title="Топливная карта" back={back} source={source} />
                        )}
                    />
                </Switch>
            </div>
        );
    }
}

export default connect(
    () => ({}),
    (dispatch) => ({
        clearParams: (params = {}) =>
            dispatch(
                fuelCardActions.mergeFuelCardsParams({
                    filters: [],
                    start: 0,
                    customFilters: {},
                    preparedFilter: {},
                    ...params,
                }),
            ),
    }),
)(FuelCards);
